import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { observable, action, makeObservable } from 'mobx'
import { withRouter, Link } from 'react-router-dom'

import { getRouterSearchParams } from 'utils/queryString.utils'
import { LoadingMask } from '@elo-kit/components/loading-mask/LoadingMask'

import { GET } from 'utils/requests.utils'

import ContentPage from 'shared/components/content-page/preview'

import Countdown from './Countdown'

@withRouter
@observer
class СontentPageBeforeStartDate extends Component {
  constructor(props) {
    super(props)
    makeObservable(this)
  }

  @observable isPageWithContentBlocks = false
  @observable loading = false

  componentDidMount() {
    const { displayCountDown, contentPagePreviewScope, contentPageBeforeId } = this.props

    if (displayCountDown) {
      this.toggleLoading(true)
      GET(`/${contentPagePreviewScope}/content_pages/${contentPageBeforeId}?screen_size=desktop`).then((resp) => {
        const { data: { contentBlocks = [] } = {}, success } = resp
        if (success) {
          this.setIsPageWithContentBlocks(!!contentBlocks.length)
        }
        this.toggleLoading(false)
      })
    }
  }

  @action setIsPageWithContentBlocks = (value) => (this.isPageWithContentBlocks = value)
  @action toggleLoading = (value) => (this.loading = value)

  render() {
    const {
      displayCountDown,
      publishDate,
      refreshCountdown,
      contentPageBeforeId,
      contentPagePreviewScope,
      match,
      history,
      contentPageStore,
      userStore,
    } = this.props

    const content =
      displayCountDown && !this.isPageWithContentBlocks ? (
        <div className='blocked-text'>
          <i className='far fa-clock' />
          <span className='will-be'>{I18n.t('react.payer.lesson.will_be_available')}</span>
          <Countdown date={new Date(publishDate)} refreshCountdown={refreshCountdown} />
        </div>
      ) : (
        <ContentPage
          id={contentPageBeforeId}
          scope={contentPagePreviewScope}
          headerHidden
          LinkComponent={Link}
          historyPush={history.push}
          urlParams={match.params}
          queryParams={getRouterSearchParams(history.location)}
          pathname={history.location.pathname}
          contentPageStore={contentPageStore}
          userStore={userStore}
        />
      )

    return this.loading ? <LoadingMask /> : content
  }
}

СontentPageBeforeStartDate.displayName = 'СontentPageBeforeStartDate'

export default СontentPageBeforeStartDate
